export const SectionHeading = ({ overline, title, lead, align = "left", testId }) => {
  return (
    <div
      data-testid={testId || "section-heading"}
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
    >
      {overline && (
        <div className="text-xs uppercase tracking-[0.28em] font-semibold text-brand-leaf mb-5 flex items-center gap-3">
          <span className="w-8 h-px bg-brand-gold" />
          {overline}
        </div>
      )}
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-brand-forest leading-[1.05]">
        {title}
      </h2>
      {lead && (
        <p className="mt-6 text-base md:text-lg text-brand-mute leading-relaxed">
          {lead}
        </p>
      )}
    </div>
  );
};
